import { z } from "zod";

export const UserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
});
export type User = z.infer<typeof UserSchema>;

export const UserListResponseSchema = z.array(UserSchema);
export type UserListResponse = z.infer<typeof UserListResponseSchema>;
